import { useMemo } from 'react';

import { useQuery } from '@tanstack/react-query';

import { getMainFirmContacts } from '../api';
import { MainFirmContact } from '../types';

export const useMainFirmContactOptions = () => {
  const mainFirmContactsQuery = useQuery({
    queryKey: ['mainFirmContacts'],
    queryFn: getMainFirmContacts,
    staleTime: Infinity,
  });

  const getUserOptions = (
    users: MainFirmContact[],
  ): { label: string; value: string }[] => {
    return users.map((user) => ({
      label: user.name,
      value: user.uuid,
    }));
  };

  return useMemo(() => {
    if (mainFirmContactsQuery.isLoading)
      return [{ label: 'Fetching users...', value: 0 }];
    if (mainFirmContactsQuery.isError)
      return [{ label: 'Error fetching users', value: 0 }];

    const users = mainFirmContactsQuery.data ?? [];

    const userOptions = getUserOptions(users);

    return [{ label: 'None (Current user)', value: 0 }, ...userOptions];
  }, [
    mainFirmContactsQuery.data,
    mainFirmContactsQuery.isLoading,
    mainFirmContactsQuery.isError,
  ]);
};
